//import React from 'react';
import React, { Component } from 'react';
import './App.css';
import Questionnaire from "./Questionnaire";
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from './components/NotFoundPage';
import PatientReportPage from './components/PatientReportPage';
import CustomErrorPage from './components/CustomErrorPage'

export default class App extends Component {
  constructor() {
    super();

    // keep security info in state for access by report component, if necessary
    // also set environment to "dev", "pre", or "prod"
    this.state = {
      //currentEnvironment: "dev",
      //currentEnvironment: "pre",
      currentEnvironment: "prod",
      currentBrand: null,
      securityInfo: null,
      customErrorMsg: null      
    };

    // bind functions for accessing state
    this.setSecurityInfo = this.setSecurityInfo.bind(this);
    this.setCustomErrorMessage = this.setCustomErrorMessage.bind(this);
    this.setCurrentBrand = this.setCurrentBrand.bind(this);
    this.getAPIBaseURL = this.getAPIBaseURL.bind(this);
    this.getAPIQuestionnaireURL = this.getAPIQuestionnaireURL.bind(this);
    this.getAPIQuestionnaireToken = this.getAPIQuestionnaireToken.bind(this);
    this.getBrandLogo = this.getBrandLogo.bind(this);
  }

  // set security info for access by other child components
  // this allows us to pivot to the report page after security verification
  setSecurityInfo(info) {
    this.setState({ securityInfo: info });
  }

  // set custom error message, called from child components
  // this allows us to have a centralized custom error page and pass in what to display
  setCustomErrorMessage(msg) {
    this.setState({ customErrorMsg: msg });
  }

  // sets the current brand, used for switching logos
  setCurrentBrand(brand) {
    this.setState({ currentBrand: brand });
  }

  // gets the base API url for different environments
  getAPIBaseURL() {
    const apiURLBaseDEV = "https://dev.watermarkmedical.com";
    const apiURLBasePRE = "https://portalpre.watermarkmedical.com";
    const apiURLBasePROD = "https://portal.watermarkmedical.com";

    let currentAPIURL = "";
    switch (this.state.currentEnvironment.toLowerCase()) {
      case "dev":
        currentAPIURL = apiURLBaseDEV;
        break;
      case "pre":
        currentAPIURL = apiURLBasePRE;
        break;
      case "prod":
        currentAPIURL = apiURLBasePROD;
        break;
      default:
        // default to DEV, if environment unknown
        currentAPIURL = apiURLBaseDEV;
        break;
    }

    return currentAPIURL;
  }

  // gets gallagher's API url for different environment
  getAPIQuestionnaireURL() {
    const API_DEV = "https://api.dev.watermarkmedical.com/questionnaire";
    const API_PROD = "https://api.prod.watermarkmedical.com/questionnaire";

    let currentAPIURL = "";
    switch (this.state.currentEnvironment.toLowerCase()) {
      case "dev":
        currentAPIURL = API_DEV;
        break;
      case "pre":
        // we'll use DEV for PRE
        currentAPIURL = API_DEV;
        break;
      case "prod":
        currentAPIURL = API_PROD;
        break;
      default:
        // default to DEV, if environment unknown
        currentAPIURL = API_DEV;
        break;
    }

    return currentAPIURL;
  }

  // gets gallagher's API token for use with his questionnaire URL
  // TODO: move this to SleepMed.Service.Main to hide token from public view
  getAPIQuestionnaireToken() {
    const API_TOKEN_DEV = "B0mUcS0JzhSjv1KOBMz140LAoPc3Itb8qKGl1WY7";
    const API_TOKEN_PROD = "Z1QVYrUP4v4d8j5MdH31M6oj4Bqlh9Ik9pySLJYa";

    let currentToken = "";
    switch (this.state.currentEnvironment.toLowerCase()) {
      case "dev":
        currentToken = API_TOKEN_DEV;
        break;
      case "pre":
        // we'll use DEV for PRE
        currentToken = API_TOKEN_DEV;
        break;
      case "prod":
        currentToken = API_TOKEN_PROD;
        break;
      default:
        // default to DEV, if environment unknown
        currentToken = API_TOKEN_DEV;
        break;
    }
    return currentToken;
  }

  // gets the current brand logo to be used for error messages and other screens
  getBrandLogo() {
    if (this.state.currentBrand === "wm") {
      return <img src="wm_logo_small.png" alt="Watermark Medical" title="Watermark Medical" height="47px" width="80px" />;
    }
    else {
      return <img src="livosa_logo_small.png" alt="Livosa" title="Livosa" height="47px" width="123px" />;
    }
  }

  render() {
      return(
        <div>
          <div className="MainForm" >
            <Switch>
              <Route path="/" render={(props) => (<Questionnaire onSetCurrentBrand={this.setCurrentBrand} onSetSecurityInfo={this.setSecurityInfo}
                onSetCustomErrorMessage={this.setCustomErrorMessage} baseAPIURL={this.getAPIBaseURL()} questionAPIURL={this.getAPIQuestionnaireURL()}
                questionAPIToken={this.getAPIQuestionnaireToken()} brandLogo={this.getBrandLogo()} />)} exact />
              <Route path="/report" render={(props) => (<PatientReportPage securityInfo={this.state.securityInfo} baseAPIURL={this.getAPIBaseURL()} />)} exact />
              <Route path={["/error", "/expired", "/complete"]} render={(props) => (<CustomErrorPage errorMsg={this.state.customErrorMsg}
                brandLogo={this.getBrandLogo()} />)} exact />
              <Route path="/NOTFOUND" component={NotFoundPage} status={404} />
            </Switch>
          </div>
        </div>
      );
  }
}
